import React, { useEffect, useState } from 'react';
import { Container, Typography, Box } from '@mui/material';
import { apiService } from './admin/apiService';

const defaultAbout = {
  title: 'About Us',
  paragraphs: [
    'Social Worker for Women Empowerment is a non-profit organization dedicated to the upliftment and empowerment of women in rural and urban areas. Founded by Babli Kumari, our NGO works towards providing education, vocational training, healthcare access, and legal support to women who have been marginalized or disadvantaged.',
    'Our vision is to create a society where women are empowered to make their own decisions, pursue their dreams, and contribute equally to the development of their communities. We believe that by investing in women, we invest in the future of our nation.',
    'Through various programs and initiatives, we strive to address issues such as gender inequality, domestic violence, lack of education, and economic dependence. Our team of dedicated volunteers and professionals works tirelessly to bring about positive change in the lives of women across Bihar and beyond.',
  ],
};

function About() {
  const [aboutData, setAboutData] = useState(defaultAbout);

  useEffect(() => {
    let mounted = true;

    apiService.getData()
      .then((data) => {
        if (!mounted) return;
        const about = data?.about || defaultAbout;
        setAboutData({
          title: about.title || defaultAbout.title,
          paragraphs: about.paragraphs?.length ? about.paragraphs : defaultAbout.paragraphs,
        });
      })
      .catch(() => {
        if (mounted) setAboutData(defaultAbout);
      });

    return () => { mounted = false; };
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h3" gutterBottom>
        {aboutData.title}
      </Typography>
      {aboutData.paragraphs.map((paragraph, index) => (
        <Box
          key={index}
          component="div"
          sx={{
            '& p': { marginBottom: 2 },
            '& ul, & ol': { paddingLeft: 3, marginBottom: 2 },
          }}
          dangerouslySetInnerHTML={{ __html: paragraph }}
        />
      ))}
    </Container>
  );
}

export default About;